/*
 * Copyright (c) 2023 Potentially Ltd
 *
 * Please see distribution for license
 */

import { GoalCardDetail } from '../../../../../shared/models';

export interface PlaylistResourceEditorGoalsStateModel {
  goalCards: GoalCardDetail[];
}

export const INITIAL_STATE: PlaylistResourceEditorGoalsStateModel = {
  goalCards: [],
};
